import type { ReactNode } from 'react';

export const symbol_keyboard_double_arrow_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m297-481 177 177q9 9 9 21t-9 21q-9 9-21 9t-21-9L234-460q-5-5-7-10t-2-11q0-6 2-11t7-10l198-198q9-9 21-9t21 9q9 9 9 21t-9 21L297-481Zm253 0 177 177q9 9 9 21t-9 21q-9 9-21 9t-21-9L487-460q-5-5-7-10t-2-11q0-6 2-11t7-10l198-198q9-9 21-9t21 9q9 9 9 21t-9 21L550-481Z"
		/>
	</svg>
);
